import type { ReactNode } from "react";
import styled from "styled-components";

const InputDescriptionInner = styled.div`
  color: ${({ theme }) => theme.nafColor.signature.black};

  > p,
  > ul {
    line-height: 1.5;
    margin-top: 0;
    font-weight: lighter;
    letter-spacing: 0px;
  }
`;

type InputDescriptionProps = {
  description: ReactNode;
};

export default function InputDescription({
  description,
}: InputDescriptionProps) {
  if (!description) return null;
  if (typeof description === "string") {
    return (
      <InputDescriptionInner
        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
        dangerouslySetInnerHTML={{ __html: description }}
      />
    );
  }
  return <InputDescriptionInner>{description}</InputDescriptionInner>;
}
